import { ActivityIndicator, ScrollView, StyleSheet, View } from "react-native";
import { PdModal, PdModalTitle } from "src/components/overlay";
import { tUseModal, useModal } from "src/providers/OverlayProvider";

import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";
import { tModalComponentProps } from "src/redux/modals/types";

const BusyModal: React.FC<tModalComponentProps> = () => {
  return (
    <PdModal style={styles.modal}>
      <ScrollView contentContainerStyle={styles.modalBody}>
        <PdModalTitle style={styles.mb4}>Loading...</PdModalTitle>
        <View style={[styles.center, styles.wFull]}>
          <ActivityIndicator color={kColors.brandDarkGreen} size="large" />
        </View>
      </ScrollView>
    </PdModal>
  );
};

const useBusyModal = (): tUseModal => {
  return useModal(BusyModal);
};

export default useBusyModal;

const styles = StyleSheet.create({
  center: {
    alignContent: "center",
    justifyContent: "center",
  },
  mb4: {
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  modal: {
    marginHorizontal: 8 * kStyleConst.kSpacing,
    maxWidth: 400,
    width: "100%",
  },
  modalBody: {
    alignItems: "flex-start",
    backgroundColor: kColors.lightBrand,
    paddingHorizontal: 6 * kStyleConst.kSpacing,
    paddingVertical: 8 * kStyleConst.kSpacing,
  },
  wFull: {
    width: "100%",
  },
});
